var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:w-full chart-container",style:({ 'min-height': _vm.minHeigth, 'height': _vm.heightContainer })},[_c('canvas',{attrs:{"id":_vm.id,"aria-label":_vm.infoResumenTexto,"tabindex":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }